import { render, staticRenderFns } from "./table-list-confe.vue?vue&type=template&id=581bc990&"
import script from "./table-list-confe.vue?vue&type=script&lang=js&"
export * from "./table-list-confe.vue?vue&type=script&lang=js&"
import style0 from "./table-list-confe.vue?vue&type=style&index=0&id=581bc990&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports